// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15JfF","rootParamsCollapsed":"styles_rootParamsCollapsed__WfK-X","rootPreviewFull":"styles_rootPreviewFull__3NZCF","loader":"styles_loader__EJTzn"};